import { type Carrier } from '../domain/Carrier'

export function formatWelcomeMessage(carrier?: Carrier) {
  if (carrier) {
    return `${carrier.name}, welcome to your command center`
  }

  return 'Welcome to your command center'
}
